import {IdPrefix} from '../idHelpers.enums';

export default function toId(prefix: IdPrefix, id: number): string {
  return `${prefix}${id}`;
}
